import classNames from 'clsx';
import React, { useRef, useState } from 'react';

import type { SliderHandles } from '@swf/components/Slider/Slider';
import Slider, { Direction } from '@swf/components/Slider/Slider';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import useTouchSupported from '@swf/core/hooks/useTouchSupported';

import styles from './StarsNavigation.scss';

export enum Variant {
  Dark = 'dark',
  Light = 'light',
  Transparent = 'transparent'
}

export interface Props {
  children?: React.ReactNode;
  classes?: {
    container?: string;
    inner?: string;
    side?: string;
  };
  variant?: Variant;
}

const StarsNavigation: React.FC<Props> = ({
  children,
  classes: { container, inner, side } = {},
  variant = Variant.Light
}) => {
  const slider = useRef<SliderHandles>(null);
  const [scroll, setScroll] = useState({ left: false, right: false });
  const touchSupported = useTouchSupported();

  return (
    <div className={classNames(styles.container, container)}>
      <button
        className={classNames(
          styles.button,
          styles.left,
          scroll.left && !touchSupported && styles.show,
          side
        )}
        onClick={() => scroll.left && slider.current?.scroll(Direction.LEFT)}
      >
        {<Arrow className="arrow" width={20} height={20} />}
      </button>
      <Slider
        className={styles[variant]}
        innerClassName={classNames(styles.nav, inner, styles[variant])}
        onScroll={setScroll}
        ref={slider}
      >
        {children}
      </Slider>
      <button
        className={classNames(
          styles.button,
          styles.right,
          scroll.right && !touchSupported && styles.show,
          side
        )}
        onClick={() => scroll.right && slider.current?.scroll(Direction.RIGHT)}
      >
        {<Arrow className="arrow" width={20} height={20} />}
      </button>
    </div>
  );
};

export default StarsNavigation;
